React = require('react');
ReactDOM = require('react-dom');
FavoritesDesktop = require('../../components/client_profile/desktop/favorites_desktop.js');

require('react_ujs');
